angular.module( 'angus.directives' ).directive( 'liquidFuels', [
	'actionViewTemplates',
	function( actionViewTemplates ) {
		'use strict';
		
		return {
			scope: {
				model: '=actionModel',
				settings: '=liquidFuelsWidgetSettings',
				widgetCode : '='
			},
			templateUrl: actionViewTemplates.liquidFuelsReportContainer
		};
	}
] );